/**
 * Le classement de cette annonce a-t-il été influencé par un paiement ?
 * (C. conso D111-6 II, Légifrance LEGIARTI000049915008, lu le 29/09/2026 :
 * « pour chaque résultat de classement, à proximité de l'offre […], l'information
 * selon laquelle son classement a été influencé par […] une rémunération ».)
 *
 * Deux cas, et seulement deux, tirés du code réel du tri
 * (`backend/routes/listings.py`, recherche et accueil) :
 *  1. « À la Une » en cours : l'annonce occupe les positions 1-2 parce qu'elle a
 *     été payée (`is_featured` + `featured_until` futur) ;
 *  2. sa date de tri (`bumped_at`) est celle posée par une option payante
 *     (`remontee_payante_at`, écrit à l'activation du boost et à chaque remontée
 *     récurrente). Une republication gratuite ou la fin du boost réécrit
 *     `bumped_at` : l'égalité tombe et la mention avec.
 */
export function classementSponsorise(listing, maintenant = new Date()) {
  if (!listing) return false;
  const iso = maintenant.toISOString();
  if (listing.is_featured && (!listing.featured_until || listing.featured_until > iso)) return true;
  return Boolean(listing.remontee_payante_at && listing.remontee_payante_at === listing.bumped_at);
}

/** Critère de tri affiché sur chaque page de résultats (D111-6 II, al. 2). */
export const CRITERES_TRI = {
  recent: {
    label: "Plus récents",
    definition: "date de publication ou de dernière remontée",
  },
  price_asc: { label: "Prix croissant", definition: "du prix le plus bas au plus élevé" },
  price_desc: { label: "Prix décroissant", definition: "du prix le plus élevé au plus bas" },
  donation: { label: "% don élevé", definition: "part du prix reversée à l'association, de la plus forte à la plus faible" },
};

export const RUBRIQUE_CLASSEMENT = "/referencement-et-classement";
